module.exports = __webpack_public_path__ + "media/vspace2.18009256.mp4";